<template>
  <div id="bankSelection" class="bank-selection">
    <div class="description">
      <div class="title">כדי להציג לך במדויק כמה כסף נכנס כל חודש, המערכת תצטרך גישה לקריאה בלבד מאתר הבנק</div>
      <div class="subtitle">באיזה בנק נמצא החשבון העיקרי שלך?
      </div>
      <info-tool-tip class="tool-tip-wrapper"
        :text="'אפשר להוסיף ולערוך את החשבונות בהמשך ההרשמה לשירות'" />
    </div>
    <separator/>
    <div v-for="source in sources" :key="source.sourceName">
      <bank-selection-item :source="source" :on-selection="onSelection"/>
      <separator/>
    </div>
    <privacy-footer class="footer"/>
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import consts from '../../../../../../constants/onboarding-state';
import PrivacyFooter from '../../../../../../base-components/onboarding/PrivacyFooter.vue';
import BankSelectionItem from '../../../../../../base-components/onboarding/BankSelectionItem.vue';
import SourceFields from '../../../../../../mixins/SourceFields.vue';
import effects from '../../../../../../store/utilities/effects';
import InfoToolTip from '../../../../../../base-components/onboarding/InfoToolTip.vue';

export default {
  name: 'BankSelection',
  mixins: [SourceFields],
  components: {
    InfoToolTip,
    BankSelectionItem,
    PrivacyFooter,
    Separator: BaseUI.Separator,
  },
  props: {
    onSelection: {
      type: Function,
    },
  },
  mounted() {
    effects.scrollToTopOfElement('bankSelection');
  },
  computed: {
    currentPageName() {
      return consts.ONBOARDING_PAGE.BANK_SELECTION;
    },
    sources() {
      return this.allSourceFieldsWithDiscountBase;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../scss/mixins';

  .bank-selection {
    .description {
      @include responsive-padding;
      margin-top: 40px;
      color: $riseup_black;

      .title {
        font-size: 22px;
        font-weight: bold;
        line-height: 1.27;
      }

      .subtitle {
        margin-top: 15px;
        font-size: 18px;
        line-height: 1.36;
        .bold {
          font-weight: bold;
        }
      }

      .tool-tip-wrapper {
        margin: 20px 0 40px;
      }
    }

    .credentials-card {
      margin-bottom: 25px;
    }

    .footer {
      position: -webkit-sticky;
      position: sticky;
      bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/onboard2/steps/bank-selection/BankSelection.vue